/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
import * as i0 from "@angular/core";
import * as i1 from "./menu/menu.ngfactory";
import * as i2 from "./menu/menu";
import * as i3 from "../../node_modules/ionic-angular/components/nav/nav.ngfactory";
import * as i4 from "ionic-angular/components/split-pane/split-pane";
import * as i5 from "ionic-angular/components/nav/nav";
import * as i6 from "ionic-angular/navigation/view-controller";
import * as i7 from "ionic-angular/navigation/nav-controller";
import * as i8 from "ionic-angular/components/app/app";
import * as i9 from "ionic-angular/config/config";
import * as i10 from "ionic-angular/platform/platform";
import * as i11 from "ionic-angular/gestures/gesture-controller";
import * as i12 from "ionic-angular/transitions/transition-controller";
import * as i13 from "ionic-angular/navigation/deep-linker";
import * as i14 from "ionic-angular/platform/dom-controller";
import * as i15 from "./app.component";
import * as i16 from "smartux-client/src/bootstrap";
import * as i17 from "./app.hooks";
var styles_ClientApp = [];
var RenderType_ClientApp = i0.ɵcrt({ encapsulation: 2, styles: styles_ClientApp, data: {} });
export { RenderType_ClientApp as RenderType_ClientApp };
export function View_ClientApp_0(_l) { return i0.ɵvid(0, [i0.ɵqud(402653184, 1, { content: 0 }), i0.ɵqud(671088640, 2, { radioGroups: 1 }), (_l()(), i0.ɵeld(2, 0, null, null, 1, "menu-component", [], null, null, null, i1.View_MenuComponent_0, i1.RenderType_MenuComponent)), i0.ɵdid(3, 245760, null, 0, i2.MenuComponent, [], null, null), (_l()(), i0.ɵted(-1, null, ["\n"])), (_l()(), i0.ɵeld(5, 0, null, null, 2, "ion-nav", [], null, null, null, i3.View_Nav_0, i3.RenderType_Nav)), i0.ɵprd(6144, null, i4.RootNode, null, [i5.Nav]), i0.ɵdid(7, 4374528, [["nav", 4]], 0, i5.Nav, [[2, i6.ViewController], [2, i7.NavController], i8.App, i9.Config, i10.Platform, i0.ElementRef, i0.NgZone, i0.Renderer, i0.ComponentFactoryResolver, i11.GestureController, i12.TransitionController, [2, i13.DeepLinker], i14.DomController, i0.ErrorHandler], null, null)], function (_ck, _v) { _ck(_v, 3, 0); }, null); }
export function View_ClientApp_Host_0(_l) { return i0.ɵvid(0, [(_l()(), i0.ɵeld(0, 0, null, null, 1, "ng-component", [], null, null, null, View_ClientApp_0, RenderType_ClientApp)), i0.ɵdid(1, 245760, null, 0, i15.ClientApp, [i16.Bootstrap, i17.Hooks], null, null)], function (_ck, _v) { _ck(_v, 1, 0); }, null); }
var ClientAppNgFactory = i0.ɵccf("ng-component", i15.ClientApp, View_ClientApp_Host_0, {}, {}, []);
export { ClientAppNgFactory as ClientAppNgFactory };
//# sourceMappingURL=app.component.ngfactory.js.map


//////////////////
// WEBPACK FOOTER
// ./src/app/app.component.ngfactory.js
// module id = 1641
// module chunks = 0